import React from "react";

const AdminUnitBreakdown = ({ adminData }) => (
    <section className="card">
        <h3>Admin Unit Breakdown</h3>
        <table>
            <thead>
                <tr>
                    <th>Code</th>
                    <th>Admin Unit</th>
                    <th>Budget</th>
                    <th>Spent</th>
                </tr>
            </thead>
            <tbody>
                {adminData.map((row, i) => (
                    <tr key={i}>
                        <td>{row.code}</td>
                        <td>{row.name}</td>
                        <td>{row.budget.toLocaleString()}</td>
                        <td>{row.spent.toLocaleString()}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </section>
);

export default AdminUnitBreakdown;